import { useEffect } from "react";
import { useAnimation } from "../hooks/useAnimation";
import { NavLink } from "react-router-dom";

const Career = () => {
    const animate = useAnimation()
    const cachedVal = sessionStorage.getItem('works')
    let works = null;
    if (cachedVal) {
        works = JSON.parse(cachedVal).content.table.tbody

        console.log('works', works);
    } else {
        const loadNews = async () => {
            try {

                const url = window.location.href.split('/')[2];
                const response = await fetch(`https://api.storyblok.com/v2/cdn/stories/?version=${url === 'fiyuu.com.tr' ? 'published' : 'draft'}&token=PU48xeT0YARVgQPLiYGmwAtt`)

                const data = await response.json()
                console.log('data', data);

                let newsies: any = [];
                let works2 = null;
                data.stories.forEach((element: any) => {
                    if (element.full_slug.indexOf('haber-ve-blog') > -1) {
                        newsies.push(element)

                    }
                });
                data.stories.forEach((element: any) => {
                    if (element.slug.indexOf('is-ilanlari') > -1) {
                        works2 = element.content.table.tbody;
                        console.log('element', element.content.table.tbody);


                    }
                });

                sessionStorage.setItem('news', JSON.stringify(newsies));

                sessionStorage.setItem('works', JSON.stringify(works2));
                works = works2;
                console.log('works 2', works);
                window.location.reload();
            } catch (error) {
            }
        }
        useEffect(() => {
            loadNews()
        }, [])
    }
    useEffect(() => {

        setTimeout(() => {
            animate()
            window.scrollTo(0, 0);
        }, 100);
    }, [])

    return (
        works &&
        <div className="career-ctr d-flex justify-content-center flex-column align-items-center">
            <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <div className="page-banner w-100 d-flex justify-content-center align-items-center">
                    <div
                        className="page-container p-0 d-flex flex-column flex-lg-row justify-content-between align-items-center align-items-lg-center">
                        <div className="page-banner__card">
                            <h1 className="page-banner__card-title mb-4" data-animation="slideInDown"
                                data-animation-delay="50ms">
                                Kariyer
                            </h1>

                            <p className="page-banner__card-text mt-3" data-animation="slideInUp" data-animation-delay="50ms">
                                Siz de ekibimizin bir parçası olun!
                            </p>
                        </div>

                        <div className="page-banner__image mt-5 mt-lg-0" data-animation="slideInLeft"
                            data-animation-delay="50ms">
                            <img src="/images/career.png" alt="" />
                        </div>
                    </div>
                </div>

                <div className="career-content d-flex justify-content-center align-items-center">
                    <div className="page-container w-100 d-flex justify-content-center align-items-center flex-column">

                        <div className="career-content__text" data-animation="fadeIn" data-animation-delay="50ms">
                            <p>
                                Modern insan kaynakları yaklaşımımızla; hedeflerimiz doğrultusunda fayda sağlayacak çalışma
                                sistemleri yaratarak,
                                çalışanlarımızın yeteneklerini ortaya çıkarmanın ve <strong>fiyuu’lu</strong> olmaktan gurur
                                duymalarını
                                sağlamanın önemine inanıyoruz.
                            </p>
                            <p>
                                Başarmaya istekli, performansını ortaya koyabilen ve daha fazla sorumluluğu taşıyabileceğine
                                inanan herkesi, ekibimizin bir parçası olmaya davet ediyoruz!
                            </p>
                            <ul className="d-flex flex-column justify-content-start align-items-start">
                                <li>
                                    Takımlar, hizmet zincirimizin bütününü oluştururlar. Kendi içlerinde olduğu gibi
                                    aralarında da yardımlaşma ve bilgi akışının sağlıklı olması temel hedeflerimizdendir.
                                    Takımların yarattığı sonuçların, çoğunlukla bireysel sonuçların toplamından daha
                                    başarılı olduğuna inanırız.
                                </li>
                                <li>
                                    Müşterilerimizin menfaatleri her zaman ön plandadır. Başarı, onlara verdiğimiz iyi
                                    hizmet sonucunda gelir. Müşterilerimize karşı her zaman açık, kesin ve şeffaf
                                    davranırız. Amacımız müşterilerimize her zaman beklentilerinin üzerinde servis
                                    sunabilmektir. İş yoğunluğumuzun servis standardımızı düşürmesine asla izin veremeyiz.
                                    Bizim için en önemlisi, müşterilerimizle uzun vadeli ilişkiler kurmaktır.
                                </li>
                            </ul>
                        </div>
                        <div className="career-content__card position-relative">
                            <svg className="oval-shape" style={{ top: '20px' }} xmlns="http://www.w3.org/2000/svg" width="194" height="172" viewBox="0 0 194 172" fill="none">
                                <path
                                    d="M-122 86C-122 38.5035 -83.4965 0 -36 0L108 0C155.496 0 194 38.5035 194 86C194 133.496 155.496 172 108 172H-36C-83.4965 172 -122 133.496 -122 86Z"
                                    fill="url(#paint0_linear_34_1901)" fillOpacity="0.5" />
                                <defs>
                                    <linearGradient id="paint0_linear_34_1901" x1="-171.809" y1="-11.4156" x2="78.8661" y2="333.282"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#D3DDEC" />
                                        <stop offset="1" stopColor="#FFEEDE" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <h2 className="text-center title" data-animation="slideInUp" data-animation-delay="50ms">
                                Siz de ekibimizin bir parçası olun!
                            </h2>
                            <p className="text-center subtext" data-animation="slideInUp" data-animation-delay="50ms">
                                Açık pozisyon ve detaylara aşağıdaki listemizden ulaşabilirsiniz.
                            </p>

                            <div className="career-cards d-flex justify-content-start align-items-start w-100 flex-column">
                                <div className="career-cards__title d-flex row m-0 w-100" data-animation="fadeIn"
                                    data-animation-delay="50ms">
                                    <span className="col-3 p-0 px-3">Açık Pozisyonlar</span>
                                    <span className="col-3 p-0 px-3">Departman</span>
                                    <span className="col-3 p-0 px-3">Bölge</span>
                                    <span className="col-3 p-0 px-3">Başvuru Linki</span>
                                </div>

                                {
                                    works?.map((item: any, index: number) => {
                                        return (


                                            <div key={index} className="career-cards__item row mx-0 w-100 ">
                                                <div className="col-3 p-0 px-3 d-flex flex-column justify-content-start align-items-start">
                                                    <h5>
                                                        {item?.body[0].value}
                                                    </h5>
                                                    <span>
                                                        {item?.body[1].value}
                                                    </span>
                                                </div>
                                                <span className="col-3 p-0 px-3">
                                                    {item?.body[2].value}
                                                </span>
                                                <span className="col-3 p-0 px-3">
                                                    {item?.body[3].value}
                                                </span>
                                                <NavLink to={item?.body[4].value} target="blank" className="col-3 p-0 px-3">
                                                    {item?.body[5].value}
                                                </NavLink>
                                            </div>


                                        )
                                    })
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Career;